import './bootstrap';
import './header';
import './contact';
// import './authentication';
import './common';
import './fixedButton';
import './language-selector';
// import './carousels-init'; // DESACTIVADO: Cada componente tiene su propio JS inline
import AOS from 'aos';
import 'aos/dist/aos.css';

// Inicializar AOS
AOS.init({
  duration: 800,
  easing: 'ease-in-out',
  once: true,
  mirror: false,
  offset: 40, // Solo animar cuando el elemento esté a punto de entrar al viewport
  disable: false,
});

// Envolver tablas en páginas legales con scroll wrapper
document.addEventListener('DOMContentLoaded', function() {

});


